@let overview = topicsOverview$ | async;

@if (overview !== undefined && overview !== null) {
    <div class="mm-topics-visualization-insight-data">
        <div class="mm-topics-visualization-insight-data-info">
            @if (topics.length > 0) {
                <div class="mm-topics-visualization-insight-data-info-text">
                    {{ 'learningGoal.insightsPopup.topics.colorExplanation' | translate }}
                </div>
            }
            @if (topics.length === 0) {
                <div class="mm-topics-visualization-insight-data-info-text">
                    {{ 'learningGoal.insightsPopup.topics.noData' | translate }}
                </div>
            }
        </div>
        @if (topics.length > 0 && squareWidth !== undefined) {
            <div class="mm-topics-visualization-insight-data-topics">
                <div class="mm-topics-visualization-insight-data-topics-chart">
                    <svg [attr.height]="size" [attr.width]="size"
                         class="mm-topics-visualization-insight-data-topics-chart-svg">
                        @for (topic of topics; track $index; let i = $index) {
                            <rect
                                [attr.height]="squareWidth"
                                [attr.width]="squareWidth"
                                [attr.x]="calculateXPosition(i)"
                                [attr.y]="calculateYPosition(i)"
                                [style.fill]="calculateBackgroundColor(topic.mastery)"
                                [style.stroke-width]="strokeWidth"
                                [style.stroke]="'white'"
                                [mmTooltip]="calculateTitle(topic)"
                            >
                            </rect>
                        }
                    </svg>
                </div>
                <div class="mm-topics-visualization-insight-legend">
                    <div class="mm-topics-visualization-insight-legend-bar">
                        <div class="mm-topics-visualization-insight-legend-bar-label">
                            {{ 'learningGoal.insightsPopup.topics.masteryLegend' | translate }}
                        </div>
                        <div class="mm-topics-visualization-insight-legend-bar-value">0%</div>
                        <div class="mm-topics-visualization-insight-legend-bar-colors">
                            @for (color of colors; track $index) {
                                <div [style.background]="color"
                                     class="mm-topics-visualization-insight-legend-bar-colors-element"></div>
                            }
                        </div>
                        <div class="mm-topics-visualization-insight-legend-bar-value">100%</div>
                    </div>
                </div>
            </div>
        }
    </div>
}
